import { Link } from 'react-router-dom';
import { ROUTES } from '@/utils/constants';
import { Home, MoveLeft, Compass } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Error404 = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-8 text-center bg-background font-sans relative overflow-hidden">
      {/* Background Accents (Optional subtle styling) */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 flex flex-col items-center max-w-lg w-full">
        {/* Decorative Icon */}
        <div className="h-20 w-20 bg-card border border-border shadow-glass rounded-2xl flex items-center justify-center mb-8 relative">
          <Compass className="h-10 w-10 text-primary animate-pulse" />
          <div className="absolute -bottom-2 -right-2 bg-foreground text-background text-[10px] font-black px-2 py-0.5 rounded-md uppercase tracking-wider shadow-sm">
            404
          </div>
        </div>

        <div className="space-y-4 mb-10">
          <h1 className="text-4xl md:text-5xl font-black text-foreground tracking-tight">
            Page Not Found
          </h1>
          <p className="text-muted-foreground text-sm md:text-base leading-relaxed max-w-[80%] mx-auto">
            The page you are looking for doesn't exist. Please check the URL or go back to the home
            page.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center gap-4 w-full justify-center">
          <Button
            variant="outline"
            onClick={() => window.history.back()}
            className="w-full sm:w-auto h-12 px-8 rounded-xl font-bold uppercase tracking-widest text-[11px] border-border hover:bg-accent transition-all text-foreground"
          >
            <MoveLeft className="h-4 w-4 mr-2" />
            Go Back
          </Button>

          <Link to={ROUTES.DASHBOARD} className="w-full sm:w-auto">
            <Button className="w-full sm:w-auto h-12 px-8 rounded-xl font-black uppercase tracking-widest text-[11px] bg-primary hover:bg-primary/90 text-white shadow-lg shadow-primary/20 border-none transition-all hover:-translate-y-0.5">
              <Home className="h-4 w-4 mr-2" />
              Go to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Error404;
